import makeStyles from '@material-ui/styles/makeStyles';

export default makeStyles(theme => ({
  moreContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));
